import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { MSteps } from '../msteps/msteps';
import { Dashboard } from '../dashboard/dashboard';
import { TranslateService } from '@ngx-translate/core';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-mq_list', 
  templateUrl: 'mq_list.html',
})
export class Mq_List extends Util{
  //NON VIENE RICHIAMATA DA NESSUNO QUESTA PAGINA
  
  pagine:any;
  user:any;
  mq_list:any;
  mqs:any = [];
  constructor(public navCtrl: NavController,public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController) {
    super(injector, loading);
    
    this.mq_list = this.navParams.get('mq_list');
    this.refreshpage(this.mq_list); 
  }
  refreshpage(mq_list){
    this.GetRequest('microQuestFase',mq_list.id).then(data=>{
     
      //console.log(data);
      
      this.mqs = data['MicroQuestList'];
      
    }).catch((e) => {
      console.error(e)
    })
  }
  open_questionario(m){ 
    this.navCtrl.push(MSteps,{mq:m}); 
  }
  go_root(){
    this.navCtrl.setRoot(Dashboard);
  }
}



// WEBPACK FOOTER //
// ./src/pages/mq_list/mq_list.ts